import { takeLatest, call, put, all } from 'redux-saga/effects';

import { ApiResponse, postApi } from 'services/_api';

import { PATH_DETRAN_CRV, CHANNEL } from 'services/_path';

import { ReducerAction } from 'store/modules/types';

import { Types, IPCOVRequest } from './types';

import { consultarPCOVSuccess, consultarPCOVFailure } from './actions';

function* consultarPCOVRequest(request: ReducerAction) {
	const { payload }: { payload: IPCOVRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CRV,
		`resumo-veiculo/${CHANNEL}/pesquisa/comunicacao-venda`,
		payload,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarPCOVSuccess(response));
	} else if (response.error) {
		yield put(consultarPCOVFailure(response));
	}
}

export default all([takeLatest(Types.PCOV_REQUEST, consultarPCOVRequest)]);
